import { Dialog as DialogPrimitive } from "radix-ui";

export const DialogPortal = DialogPrimitive.Portal;
